
import { IDiemDanhPhongNamHocChangeRequest } from "../models/request/diem-danh/IDiemDanhPhongNamHocChangeRequest";
import { IBaoCaoDiemDanhRequest, IDiemDanhPhongNamHocSelectRequest } from "../models/request/diem-danh/IDiemDanhPhongNamHocSelectRequest";
import { apiClient } from "./apiClient";

export const API_DIEMDANH_PATH = "diem-danh"
export const diemDanhApi = {
    SelectByPhongNamHocAsync: (request: IDiemDanhPhongNamHocSelectRequest) => {
        return apiClient.post(`${API_DIEMDANH_PATH}/select-by-phong-nam-hoc`, request)
    },
    DiemDanhPhongNamHocAsync: (request: IDiemDanhPhongNamHocChangeRequest) => {
        return apiClient.post(`${API_DIEMDANH_PATH}/diem-danh-phong-nam-hoc`, request)
    },
    SelectByThangAsync: (request: IBaoCaoDiemDanhRequest) => {
        return apiClient.post(`${API_DIEMDANH_PATH}/select-bao-cao-diem-danh-by-thang`, request)
    },
};